module.exports = __webpack_public_path__ + "static-portal/img/bg-3.fw.be52f97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-3.fw.png
// module id = jz4J
// module chunks = 4